import { inject, Injectable, signal } from '@angular/core';
import { TransportFormService } from './transport-form.service';
import { AccommodationFormService } from './accommodation-form.service';
import { ActivityFormService } from './activity-form.service';
import { MealFormService } from './meal-form.service';

export enum PrestationModalContent {
  SelectPrestation = 'selectPrestation',
  AddTransport = 'addTransport',
  AddAccommodation = 'addAccommodation',
  AddActivity = 'addActivity',
  AddMeal = 'addMeal',
}

@Injectable({
  providedIn: 'root',
})
export class PrestationModalService {
  showModal = signal(false);
  modalContent = signal<PrestationModalContent | null>(null);
  transportFormService = inject(TransportFormService);
  accommodationFormService = inject(AccommodationFormService);
  activityFormService = inject(ActivityFormService);
  mealFormService = inject(MealFormService);

  close() {
    this.showModal.set(false);
    this.modalContent.set(null);
    this.transportFormService.step.set(1);
  }

  selectPrestation(): void {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.SelectPrestation);
  }
  addTransport() {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddTransport);
    this.transportFormService.resetFormGroup();
  }
  editTransport(index: number) {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddTransport);
    this.transportFormService.editTransport(index);
  }
  addAccommodation() {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddAccommodation);
    this.accommodationFormService.resetFormGroup()
  }
  editAccommodation(index: number) {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddAccommodation);
    this.accommodationFormService.editAccommodation(index);
  }
  addActivity() {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddActivity);
  }
  editActivity(index: number) {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddActivity);
    this.activityFormService.editActivity(index);
  }
  addMeal() {
    this.showModal.set(true);
    this.mealFormService.resetFormGroup();
    this.modalContent.set(PrestationModalContent.AddMeal);
  }
  editMeal(index: number) {
    this.showModal.set(true);
    this.modalContent.set(PrestationModalContent.AddMeal);
    this.mealFormService.editMeal(index);
  }
}
